"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = require("@material-ui/core/styles");
var _Button = _interopRequireDefault(require("../../Button"));
var _excluded = ["label", "onClick"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    actionBar: {
      alignItems: 'center',
      borderTop: '1px solid rgba(0, 0, 0, 0.14)',
      display: 'flex',
      height: 48,
      justifyContent: 'flex-end',
      marginTop: 'auto',
      padding: theme.spacing(1)
    },
    buttonAligment: {
      marginRight: theme.spacing(1)
    },
    iconOnly: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1)
    },
    leftAlign: {
      alignItems: 'center',
      left: theme.spacing(1),
      position: 'absolute'
    },
    primaryButton: {
      marginLeft: theme.spacing(1)
    }
  };
});
var ActionFooter = function ActionFooter(props) {
  var ariaLabel = props['aria-label'],
    className = props.className,
    actionFooterProps = props.actionFooterProps,
    disabled = props.disabled,
    size = props.size,
    handleChangeFocus = props.handleChangeFocus;
  var componentClasses = useStyles();
  var buttonRefs = actionFooterProps.map(function () {
    return /*#__PURE__*/(0, _react.createRef)();
  });
  var footerList = (0, _toConsumableArray2["default"])(actionFooterProps);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(componentClasses.actionBar)
  }, footerList.reverse().map(function (_ref, idx, arr) {
    var _cx;
    var label = _ref.label,
      _onClick = _ref.onClick,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
    var iconOnly = !label;
    return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({
      "aria-label": ariaLabel,
      className: (0, _classnames["default"])(className, (_cx = {}, (0, _defineProperty2["default"])(_cx, componentClasses.buttonAligment, Boolean(idx) && idx !== arr.length - 1), (0, _defineProperty2["default"])(_cx, componentClasses.leftAlign, idx === 0), _cx)),
      classes: {
        outlined: iconOnly && componentClasses.iconOnly
      },
      disabled: disabled,
      key: label,
      onClick: function onClick(e) {
        return _onClick(e, idx);
      },
      iconPosition: "left",
      ref: buttonRefs[idx],
      variant: idx === arr.length - 1 ? 'contained' : 'text',
      onKeyUp: function onKeyUp(event) {
        if (event.key === 'ArrowLeft') {
          if (idx > 0) {
            buttonRefs[idx - 1].current.focus();
          }
        }
        if (event.key === 'ArrowRight') {
          if (idx < arr.length - 1) {
            buttonRefs[idx + 1].current.focus();
          }
        }
        if (event.key === 'Enter' || event.code === 'Space') {
          _onClick(event, idx);
        }
      },
      size: size
    }, rest, {
      onKeyDown: function onKeyDown(event) {
        if (idx === arr.length - 1 && event.key === 'Tab') {
          handleChangeFocus();
        }
      }
    }), label);
  }));
};
var defaultProps = {
  'aria-label': 'Footer Button',
  disabled: false,
  size: 'small'
};
ActionFooter.defaultProps = defaultProps;
ActionFooter.propTypes = process.env.NODE_ENV !== "production" ? {
  actionFooterProps: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired,
    onClick: _propTypes["default"].func.isRequired
  })),
  /**
   * The aria-label to pass to the footer component.
   */
  'aria-label': _propTypes["default"].string,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * If `true`, the Button will be disabled.
   */
  disabled: _propTypes["default"].bool,
  /**
   *  change focus when the we press tab on last button
   */
  handleChangeFocus: _propTypes["default"].func,
  /**
   * The size of the buttons in the footer.
   */
  size: _propTypes["default"].oneOf(['small', 'medium'])
} : {};
var _default = ActionFooter;
exports["default"] = _default;